import { AnalyticsModelSummary, VersionStatus } from '../config';

export type AnalyticsModelOrderingContext = {
  organizationId?: string | null;
  parentOrganizationId?: string | null;
};

const VERSION_STATUS_ORDER: Record<VersionStatus, number> = {
  active: 0,
  draft: 1,
  deleted: 2,
};

const getOwnershipPriority = (
  model: AnalyticsModelSummary,
  context: AnalyticsModelOrderingContext,
): number => {
  if (
    context.organizationId &&
    model.organization_id === context.organizationId
  ) {
    return 0;
  }

  if (
    context.parentOrganizationId &&
    model.organization_id === context.parentOrganizationId
  ) {
    return 1;
  }

  if (model.organization_id == null) {
    return 2;
  }

  return 3;
};

export const sortAnalyticsModelsForDisplay = <T extends AnalyticsModelSummary>(
  models: T[],
  context: AnalyticsModelOrderingContext = {},
): T[] => {
  const collator = new Intl.Collator(undefined, {
    sensitivity: 'base',
    numeric: true,
  });

  return [...models].sort((a, b) => {
    const ownershipDiff =
      getOwnershipPriority(a, context) - getOwnershipPriority(b, context);
    if (ownershipDiff !== 0) {
      return ownershipDiff;
    }

    const statusDiff =
      VERSION_STATUS_ORDER[a.status] - VERSION_STATUS_ORDER[b.status];
    if (statusDiff !== 0) {
      return statusDiff;
    }

    const versionDiff = b.version - a.version;
    if (versionDiff !== 0) {
      return versionDiff;
    }

    return collator.compare(a.name || a.id, b.name || b.id);
  });
};
